import styled from 'styled-components'

export function PredictedTrafficBadge({
  value,
  className,
  size = 'default',
}: {
  value: string | null
  className?: string
  size?: 'default' | 'small'
}) {
  const getColorProps = (value: string | null) => {
    const value_lower = value?.toLowerCase() || 'unavailable'
    if (value_lower === 'very high')
      return { color: '#00876C', backgroundColor: '#e6f3f1' }
    if (value_lower === 'high')
      return { color: '#64901B', backgroundColor: '#eff5e4' }
    if (value_lower === 'average')
      return { color: '#E08B20', backgroundColor: '#fef6ec' }
    if (value_lower === 'low')
      return { color: '#D43D51', backgroundColor: '#fbecee' }
    return { color: '#959595' }
  }

  return (
    <div className="flex">
      <Badge {...getColorProps(value)} className={className} size={size}>
        {value ?? 'Unavailable'}
      </Badge>
    </div>
  )
}

const Badge = styled.div<{
  color?: string
  backgroundColor?: string
  size?: 'default' | 'small'
}>`
  border-radius: 10px;
  font-weight: 500;
  ${({ color }) => color && `color: ${color};`}
  ${({ backgroundColor }) =>
    backgroundColor && `background-color: ${backgroundColor};`}

  /* Size variants */
  ${({ size }) =>
    size === 'small'
      ? `
        font-size: 0.875rem; /* text-sm */
        padding: 0.25rem 0.5rem; /* px-2 py-1 */
      `
      : `
        font-size: 85%;
        padding: 2px 8px;
      `}
`
